import { useEffect, useState } from 'react';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle, setDrawerOpen } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { TableContentForMechanic } from 'entities/table/ui/TableContentForMechanic';
import { useGetTestQuery, useGetPhonesQuery } from 'features/getParticipants/api/getParticipantsApi';
import { useGetConstantsQuery } from 'features/getParticipants/api/getConstantsApi';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { TabContext } from '@mui/lab';
import { StyledTab, StyledTabList, StyledTabPanel } from 'shared/styles/StyledTabs';
import { DrawerShopDotsChange } from 'widgets/shopDots/ui/DrawerShopDotsChange';
import { DrawerShopDotsPhone } from 'widgets/shopDots/ui/DrawerShopDotsPhone';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { useDeletePhoneMutation } from 'features/createParticipant/createParticipant';

export const ShopDotsDetail = () => {
  const { id } = useParams();
  const [tab, setTab] = useState('1');
  const handleChangeTab = (_: React.SyntheticEvent, newTab: string) => setTab(newTab);
  const { data: constantsList } = useGetConstantsQuery(null);
  const { data: participantsById } = useGetTestQuery(parseInt(id!));
  const { data: phoneList } = useGetPhonesQuery(id!);

  const mlist = { list: [] as any };
  mlist.list.push({
    phone: 'нет пользователя в торговой точке',
    user: ' ',
  });
  const { data: cityList } = useGetCitiesQuery({});
  const data = {
    id,
    title: participantsById?.title,
    city: cityList?.find((citi) => citi.id === participantsById?.city_id)?.name,
    address: participantsById?.door_code,
    status: constantsList?.['SalesPoint.Status'].ACTIVE === participantsById?.status ? 'Активный' : 'Блокированный',
    direction:
      constantsList?.['SalesPoint.Direction'].DS === participantsById?.direction
        ? 'DS'
        : constantsList?.['SalesPoint.Direction'].KAM === participantsById?.direction
        ? 'KAM'
        : 'OP',
    tier:
      constantsList?.['SalesPoint.Tier'].LOW === participantsById?.tier
        ? 'LOW'
        : constantsList?.['SalesPoint.Tier'].TOP === participantsById?.tier
        ? 'TOP'
        : 'MIDDLE',
  };
  const [drawerVariant, setDrawerVariant] = useState<{
    variant: 'create' | 'edit' | 'createPhone';
    title: string;
  }>({
    variant: 'edit',
    title: 'Изменить данные',
  });
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
  }>({
    page: 1,
    count: 10,
  });
  const [removePhoneRequest] = useDeletePhoneMutation();

  const handleDeletePhone = (id: number) => {
    removePhoneRequest({
      sales_id: parseInt(data.id!),
      id,
    }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setHeaderTitle('Торговая точка'));
  }, [dispatch]);

  return (
    <>
      <TabContext value={tab}>
        <StyledTabList onChange={handleChangeTab}>
          <StyledTab
            label="Информация"
            value="1"
            disableRipple
            onClick={() => {
              setDrawerVariant({
                variant: 'edit',
                title: 'Изменить данные',
              });
              dispatch(setHeaderAction('edit'));
              dispatch(setActionBtnTitle('Изменить данные'));
            }}
          />
          <StyledTab
            label="Номера и пользователи торговой точки"
            value="2"
            disableRipple
            onClick={() => {
              setDrawerVariant({
                variant: 'createPhone',
                title: 'Создать',
              });
              dispatch(setHeaderAction('createPhone'));
              dispatch(setActionBtnTitle('Создать номер для торговой точки'));
            }}
          />
        </StyledTabList>

        <StyledTabPanel value="1">
          <Box
            component={StyledCard}
            sx={{
              marginBottom: '24px',
            }}
          >
            <Typography>Адресная информация</Typography>
            <Box
              style={{
                display: 'flex',
                marginTop: '12px',
              }}
            >
              <div
                className="column"
                style={{ width: '600px' }}
              >
                <MoreInfo>
                  <div className="title">ID</div>
                  <div className="content">{data?.id ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Город</div>
                  <div className="content">{data?.city ?? '---'}</div>
                </MoreInfo>
              </div>
              <div
                className="column"
                style={{ width: '600px' }}
              >
                <MoreInfo>
                  <div className="title">Наименование</div>
                  <div className="content">{data?.title ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Код двери</div>
                  <div className="content">{data?.address ?? '---'}</div>
                </MoreInfo>
              </div>
              <div
                className="column"
                style={{ width: '600px' }}
              >
                <MoreInfo>
                  <div className="title">Статус</div>
                  <div className="content">{data?.status ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Канал</div>
                  <div className="content">{data?.direction ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Уровень</div>
                  <div className="content">{data?.tier ?? '---'}</div>
                </MoreInfo>
              </div>
            </Box>
          </Box>
        </StyledTabPanel>
        <StyledTabPanel value="2">
          <TableContentForMechanic
            fields={[
              {
                field: 'id',
                title: 'ID',
                width: '20%',
              },
              {
                field: 'phone',
                title: 'Номер телефона',
                width: '40%',
              },
              {
                field: 'user',
                title: 'Пользователь',
                width: '40%',
              },
            ]}
            list={{
              list:
                phoneList?.length === 0
                  ? mlist.list
                  : phoneList?.map((item) => ({
                      id: item.id,
                      phone: item.phone,
                      user: `${item.user?.first_name ?? ''} ${item.user?.last_name ?? ''} ${
                        item.user?.middle_name ?? ''
                      }`,
                    })),
            }}
            title="Номера и пользователи торговой точки"
            onSearch={() => {}}
            count={phoneList?.length || 0}
            page={pagination.page - 1}
            perPage={pagination.count}
            onPageChange={(_, page) => {
              setPagination((prev) => ({
                ...prev,
                page: page + 1,
              }));
            }}
            onRowsPerPageChange={(e) => {
              setPagination(() => ({
                page: 1,
                count: parseInt(e.target.value),
              }));
            }}
            onRowClick={() => {}}
            onDeleteClick={handleDeletePhone}
            onChangeClick={() => {}}
          />
        </StyledTabPanel>
      </TabContext>
      <DrawerContent>
        <div className="content">
          {drawerVariant.variant === 'edit' && <DrawerShopDotsChange shopDots={data} />}
          {drawerVariant.variant === 'createPhone' && <DrawerShopDotsPhone id_shop={id || ''} />}
        </div>
      </DrawerContent>
    </>
  );
};
